import Vue from 'vue'
import Vuex from 'vuex'
import VueAuthenticate from 'vue-authenticate'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'

import 'vuetify/dist/vuetify.min.css'

import router from './router'
import store from './store'

Vue.use(Vuetify, {
//    iconfont: 'fa' // 'md' || 'mdi' || 'fa' || 'fa4'
})

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API
axios.defaults.validateStatus = (status) => {
    return status < 600;
}


Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
    tokenName: 'access_token',
    baseUrl: process.env.VUE_APP_BACKEND_API,
    storageType: 'cookieStorage',
    providers: {
        // Define OAuth providers config
    },
    bindRequestInterceptor: function () {
        this.$http.interceptors.request.use((config) => {
            if (this.isAuthenticated()) {
                config.headers['Authorization'] = [this.options.tokenType, this.getToken()].join(' ')
            } else {
                delete config.headers['Authorization']
            }
            return config
        })
    },
    bindResponseInterceptor: function () {
        this.$http.interceptors.response.use((response) => {
            this.setToken(response)
            return response
        })
    }
})

Vue.use(Vuex)
Vue.config.productionTip = false

function testAuth(rules,user) {
    return rules.some(function (val) {
        const level = val.meta.level || 0
        const roles = val.meta.roles || ''
        // eslint-disable-next-line
        console.log("!!!", level, roles)
        if (level <= user.level) {
            if (roles) {
                // eslint-disable-next-line
                console.log("!!!ul - ", user.roles)

                return !(roles.filter(x => user.roles.includes(x)));
            }
            else return false
        }
        // eslint-disable-next-line
        console.log("!!!nolevel", level, user.level)
        return true
    })

}


router.beforeEach((to, from, next) => {
    let authData = to.matched.some(record => record.meta.requiresAuth)
    if (authData) {
        // eslint-disable-next-line
        console.log(to.matched, store.state)
        if (!store.state.isAuthenticated) {
            // eslint-disable-next-line
            console.log('redirect:', to.fullPath, 'from:', from.fullPath)
            next({path: '/checkLogin', query: {redirect: to.fullPath}})
        } else {
            const tst = testAuth(to.matched,store.state.user)
            // eslint-disable-next-line
            //console.log("!!!tst", tst)
            if(tst) next({path: '/checkLogin', query: {redirect: to.fullPath}})
            else next()
        }
    } else {
        next()
    }
})


new Vue({
    router,
    store,
    render: h => h(App),
    mounted: function(){
/*        let this_ = this
        this.$store.dispatch('checkLogin', {}).then(function () {
            this_.$router.push('/home')
        })*/

    }
}).$mount('#app')

